import React from 'react';
import icon from './logo_facebook.png';

class IconFaceBook extends React.Component {
  static propTypes = {
    style: React.PropTypes.object
  };

  static defaultProps = {
    style: {}
  };

  render() {
    let {style} = this.props;

    return (
      <span style={{
        backgroundImage: `url(${icon})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'inline-block',
        height: 30,
        width: 30,
        ...style
      }}></span>
    );
  }
}

export default IconFaceBook;



// WEBPACK FOOTER //
// ./src/components/Icons/IconFaceBook.js